import { render, staticRenderFns } from "./edit-Curricula.vue?vue&type=template&id=53658558&"
import script from "./edit-Curricula.vue?vue&type=script&lang=js&"
export * from "./edit-Curricula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports